import { Component, OnInit } from '@angular/core';
import { AspMyReturnsService } from './asp-my-returns.service';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { HttpErrorResponse } from '@angular/common/http';
import { connect } from 'tls';

@Component({
  selector: 'app-asp-my-returns',
  templateUrl: './asp-my-returns.component.html',
  styleUrls: ['./asp-my-returns.component.scss']
})
export class AspMyReturnsComponent implements OnInit {

  selectedTab: string = 'All';
  searchText: string = '';
  showPopup = false;
  selectedItem: any = null;
  isInputVisible: boolean = false;
  emptyList: any = 'assets/images/no-cart.png';

  // 🔹 Will hold API data
  returnList: any[] = [];
  filteredData: any[] = [];
  data: any[] = [];
  Messages: any;
  noReturnFoundVideoLink: string = '';
  loading: boolean = false;

  constructor(
    private aspMyReturnsService: AspMyReturnsService,
    private aspLoadingService: AspLoadingService,
  ) {}

  ngOnInit(): void {
    this.fetchLateRetrn();   // 👈 Load API data on init
    this.getLoadingMsg();
  }

  get filteredList() {
    if (this.selectedTab === 'All') {
      return this.returnList;
    }
    return this.returnList.filter(item => item.status === this.selectedTab);
  }
// get filteredList() {
//   if (this.selectedTab === 'All') return this.returnList;
//   return this.returnList.filter(item => item.status === this.selectedTab);
// }


  setTab(tab: string): void {
    this.selectedTab = tab;
  }

  toggleSearch(): void {
    this.isInputVisible = !this.isInputVisible;
    if (this.isInputVisible) {
      setTimeout(() => {
        const input = document.querySelector('.custom-input-wrapper') as HTMLInputElement;
        if (input) {
          input.focus();
        }
      }, 0);
    }
  }

  clearSearch(): void {
    event.stopPropagation();
    this.searchText = '';
    this.isInputVisible = false;
    this.filteredData = [...this.data];
  }

//  onInputChange(): void {
//     if (!this.isInputVisible) return;
//   const text = this.searchText?.toLowerCase() || '';
//      console.log("-----------------------",this.searchText)
  
//   if (text) {
//     this.filteredData = this.data.filter(item => {
//       const returnId = item.returnId?.toLowerCase() || '';
//       const itemNotes = item.items?.[0]?.notes?.toLowerCase() || '';
//       const salesNotes = item.salesReturnInfo?.notes?.toLowerCase() || '';
      
//       return returnId.includes(text) || itemNotes.includes(text) || salesNotes.includes(text);
//     });
//   } else {
//     this.filteredData = [...this.data];
//   }
// }


onInputChange(): void {
  if (!this.isInputVisible) return;

  const text = this.searchText?.toLowerCase() || '';

  if (text) {
    this.filteredData = this.data.filter(item => {

      const returnId = item.returnId?.toLowerCase() || '';
      const itemNotes = item.items?.map(i => i.notes?.toLowerCase()).join(' ') || '';
      const itemReason = item.items?.map(i => i.reason?.toLowerCase()).join(' ') || '';
      const partNumbers = item.items?.map(i => i.partNumber?.toLowerCase()).join(' ') || '';

      const salesReason = item.salesReturnInfo?.reason?.toLowerCase() || '';
      const salesNotes = item.salesReturnInfo?.notes?.toLowerCase() || '';

      // 🔥 MAIN FIX
      const orderId = item.salesReturnInfo?.orderId?.toLowerCase() || '';
      const orderNumber = item.salesReturnInfo?.orderNumber?.toLowerCase() || '';
      const zohoOrderId = item.salesReturnInfo?.zohoOrderId?.toLowerCase() || '';
      const soNumber = item.salesReturnInfo?.salesOrderNumber?.toLowerCase() || '';
       const invoiceNo =
        item.salesReturnInfo?.invoiceNumbers?.length
          ? item.salesReturnInfo.invoiceNumbers[0].toLowerCase()
          : '';

      return (
        returnId.includes(text) ||
        itemNotes.includes(text) ||
        itemReason.includes(text) ||
        partNumbers.includes(text) ||
        salesReason.includes(text) ||
        salesNotes.includes(text) ||

        // 🔥 supports both responses
        orderId.includes(text) ||        
        orderNumber.includes(text) ||      
        zohoOrderId.includes(text) ||      
        soNumber.includes(text)   ||
         invoiceNo.includes(text)         
      );
    });
  } else {
    this.filteredData = [...this.data];
  }
}

  getLoadingMsg() {
    this.aspLoadingService.getLoadingMsg().subscribe(
      result => {
        let res = JSON.parse(JSON.stringify(result));
        this.Messages = res.data.appLoadingMessages;
        this.noReturnFoundVideoLink = res.data.noReturnFoundVideoLink;
  
        // Call getRandomMessage only after the Messages array is populated
        // this.getRandomMessage();
        
      },
      error => {
        console.error('Error fetching loading messages', error);
      }
    );
  }

  openReturnVideo() {
  if (this.noReturnFoundVideoLink) {
    window.open(this.noReturnFoundVideoLink, '_blank');
  } else {
    console.error("Video link not available");
  }
}

// onInputChange(): void {
//   if (!this.isInputVisible) return;

//   const text = this.searchText?.toLowerCase() || '';
//   console.log("-----------------------", this.searchText);

//   if (text) {
//     this.filteredData = this.data.filter(item => {
//       const returnId = item.returnId?.toLowerCase() || '';
//       const allNotes = item.items?.map(i => i.notes?.toLowerCase()).join(' ') || '';
//       const salesNotes = item.salesReturnInfo?.notes?.toLowerCase() || '';

//       return (
//         returnId.includes(text) ||
//         allNotes.includes(text) ||
//         salesNotes.includes(text)
//       );
//     });
//   } else {
//     this.filteredData = [...this.data];
//   }
// }


  openPopup(item: any): void {
    this.selectedItem = item;
    this.showPopup = true;
  }

  closePopup(): void {
    this.showPopup = false;
    this.selectedItem = null;
  }
fetchLateRetrn(): void {
  this.aspLoadingService.show();
  const garageKey = localStorage.getItem('garageKey');

  this.aspMyReturnsService.getLateRetrns(garageKey).subscribe(
    (result: any) => {
      this.aspLoadingService.hide();

      if (result && result.code === 200) {
        this.returnList = result.data.map((item: any) => {
          const history = item.statusHistory || [];

          let status = "Created"; // default

          if (history.some(h => h.activity?.toLowerCase() === "declined")) {
            status = "Declined";
          } 
          else if (history.some(h => h.activity?.toLowerCase() === "closed")) {
            // If closed, always mark as Refunded
            status = "Refunded";
          }
          else if (history.some(h => h.refundStatus?.toLowerCase() === "refunded")) {
            status = "Refunded";
          }
          else if (history.some(h => h.receiveStatus?.toLowerCase() === "received")) {
            status = "Received";
          }
          else if (history.some(h => h.activity?.toLowerCase() === "approved")) {
            status = "Created";
          }

          return {
            ...item,
            status,
            latestActivity: status
          };
        });

        this.data = [...this.returnList];
        this.filteredData = [...this.returnList];

        // console.log('✅ Returns mapped:', this.returnList);
      }
    },
    (error: HttpErrorResponse) => {
      this.aspLoadingService.hide();
      // console.error('❌ Error fetching returns:', error);
    }
  );
}
  get createdCount(): number {
    return (this.returnList || []).filter(item => item.latestActivity === 'Created').length;
  }

  get receivedCount(): number {
    return (this.returnList || []).filter(item => item.latestActivity === 'Received').length;
  }

  get refundedCount(): number {
    return (this.returnList || []).filter(item => item.latestActivity === 'Refunded').length;
  }

  get declinedCount(): number {
    return (this.returnList || []).filter(item => item.latestActivity === 'Declined').length;
  }


getStatusClass1(status: string): string {
  // console.log("status----",status)
  switch ((status || "").toLowerCase()) {
    case "approved":
    case "created": 
      return "status-created";   
    case "declined": 
      return "status-declined"; 
    case "refunded": 
      return "status-refunded"; // ✔ Refunded includes closed
    case "received":
      return "status-received"; 
    default: 
      return "";
  }
}

getStatusClass(status: string): string {
  const tab = (this.selectedTab || "").toLowerCase();
  const s = (status || "").toLowerCase();

  // 1️⃣ If selected tab is Refunded or Declined → force all amount color
  if (tab === "refunded") return "amount-refunded";
  if (tab === "declined") return "amount-declined";

  // 2️⃣ Otherwise → check item status
  switch (s) {
    case "refunded":
      return "amount-refunded";   // green

    case "declined":
      return "amount-declined";   // red

    default:
      return "";  // normal blue color
  }
}


mapStatus(status: string): string {
  switch ((status || "").toLowerCase()) {
    case "approved": return "Created";   // 👈 show as "Created"
    case "declined": return "Declined";
    case "refunded": return "Refunded";
    default: return status || "Unknown";
  }
}
downloadCreditNote(item: any): void {
  if (item.creditNoteUrl) {
    window.open(item.creditNoteUrl, '_blank');
  } else {
    if (!item.creditNoteId || !item.creditNoteNumber) {
      // console.error('❌ Missing credit note details', item);
      return;
    }

    this.aspMyReturnsService.createCreditNoteUrl(item.creditNoteId, item.creditNoteNumber)
      .subscribe({
        next: (res: any) => {
          if (res?.code === 200 && res?.data?.length > 0 && res.data[0].pdfUrl) {
            const url = res.data[0].pdfUrl;
            item.creditNoteUrl = url; // cache
            window.open(url, '_blank');
          } else {
            console.warn('⚠️ Credit Note URL could not be generated');
          }
        },
        error: (err) => {
          console.error('❌ Error creating Credit Note URL:', err);
        }
      });
  }
}
// TypeScript - put this in your component/service where parseDateString lives
parseDateString(dateStr: string | number | Date | null): Date | null {
  if (!dateStr && dateStr !== 0) return null;

  // If already a Date
  if (dateStr instanceof Date) {
    return isNaN(dateStr.getTime()) ? null : dateStr;
  }

  // If numeric (could be ms or seconds)
  if (typeof dateStr === 'number') {
    let ts = dateStr;
    // If looks like seconds (e.g. ~1.7e9) convert to ms
    if (ts < 1e12) ts = ts * 1000;
    const d = new Date(ts);
    return isNaN(d.getTime()) ? null : d;
  }

  // Now it's a string
  const s = (dateStr as string).trim();

  // If string is purely numeric (timestamp as string)
  if (/^\d+$/.test(s)) {
    let ts = parseInt(s, 10);
    if (ts < 1e12) ts = ts * 1000;
    const d = new Date(ts);
    return isNaN(d.getTime()) ? null : d;
  }

  // dd/MM/yyyy or dd/MM/yyyy HH:mm(:ss)
  const slashMatch = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
  if (slashMatch) {
    const day = +slashMatch[1], month = +slashMatch[2], year = +slashMatch[3];
    const hour = +(slashMatch[4] || 0), minute = +(slashMatch[5] || 0), second = +(slashMatch[6] || 0);
    const d = new Date(year, month - 1, day, hour, minute, second);
    return isNaN(d.getTime()) ? null : d;
  }

  // yyyy-MM-dd or yyyy-dd-MM (+ optional time)
  const dashMatch = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[T\s](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
  if (dashMatch) {
    const year = +dashMatch[1], partA = +dashMatch[2], partB = +dashMatch[3];
    const hour = +(dashMatch[4] || 0), minute = +(dashMatch[5] || 0), second = +(dashMatch[6] || 0);

    const asYearMonthDay = new Date(year, partA - 1, partB, hour, minute, second); // yyyy-MM-dd
    const asYearDayMonth = new Date(year, partB - 1, partA, hour, minute, second); // yyyy-dd-MM

    const validA = !isNaN(asYearMonthDay.getTime());
    const validB = !isNaN(asYearDayMonth.getTime());

    if (validA && !validB) return asYearMonthDay;
    if (!validA && validB) return asYearDayMonth;
    if (validA && validB) {
      // Both valid (ambiguous). Pick the one closer to "now".
      const now = new Date();
      const diffA = Math.abs(asYearMonthDay.getTime() - now.getTime());
      const diffB = Math.abs(asYearDayMonth.getTime() - now.getTime());
      return diffA <= diffB ? asYearMonthDay : asYearDayMonth;
    }
  }

  // Last fallback: let Date try to parse (ISO etc.)
  const fallback = new Date(s);
  return isNaN(fallback.getTime()) ? null : fallback;
}


// parseDateString(dateStr: string | number | null): Date | null {
//   if (!dateStr) return null;

//   // If it's already a number (timestamp)
//   if (typeof dateStr === 'number') {
//     const date = new Date(dateStr);
//     return isNaN(date.getTime()) ? null : date;
//   }

//   // If it's a string
//   if (typeof dateStr === 'string') {
//     // dd/MM/yyyy
//     if (dateStr.includes('/')) {
//       const [day, month, year] = dateStr.split('/');
//       const date = new Date(+year, +month - 1, +day);
//       return isNaN(date.getTime()) ? null : date;
//     }

//     // yyyy-MM-dd or yyyy-dd-MM
//     if (dateStr.includes('-')) {
//       const parts = dateStr.split('-');
//       if (parts.length === 3) {
//         if (+parts[1] > 12) {
//           const date = new Date(+parts[0], +parts[2] - 1, +parts[1]);
//           return isNaN(date.getTime()) ? null : date;
//         }
//         const date = new Date(+parts[0], +parts[1] - 1, +parts[2]);
//         return isNaN(date.getTime()) ? null : date;
//       }
//     }

//     const fallback = new Date(dateStr);
//     return isNaN(fallback.getTime()) ? null : fallback;
//   }

//   return null;
// }

hasRefundedStatus(item: any): boolean {
  return item?.statusHistory?.some((s: any) => s.refundStatus === 'refunded');
}

getLatestDate(history: any[], key: string): string | null {
  if (!history || !history.length) return null;

  const validDates = history
    .map(h => h[key])
    .filter(d => !!d);

  if (!validDates.length) return null;

  // Sort chronologically
  validDates.sort((a, b) => {
    const da = this.parseDateString(a)?.getTime() || 0;
    const db = this.parseDateString(b)?.getTime() || 0;
    return da - db;
  });

  return validDates[validDates.length - 1];
}

formatDate(dateStr: string | null): Date | null {
  if (!dateStr) return null;
  let [year, day, month] = dateStr.split("-");
  return new Date(`${year}-${month}-${day}`);
}
getInvoiceNumber(item: any): string {
  return item?.salesReturnInfo?.invoiceNumbers?.length
    ? item.salesReturnInfo.invoiceNumbers[0]
    : 'N/A';
}

getSelectedInvoiceNumber(): string {
  return this.selectedItem?.salesReturnInfo?.invoiceNumbers?.length
    ? this.selectedItem.salesReturnInfo.invoiceNumbers[0]
    : 'N/A';
}

}
